export const SET_OFFICIAL_SHOP_THEME = 'SET_OFFICIAL_SHOP_THEME';

export function setOfficialShopTheme(enable: boolean): {
  type: string;
  enable: boolean;
} {
  return { type: SET_OFFICIAL_SHOP_THEME, enable };
}
